export const mutations = {
    setEtiqueta(state, payload) {
        state.etiqueta = payload
    },
    setEtiquetas(state, payload) {
        state.etiquetas = payload
    },
    addEtiqueta(state, data){
        state.etiquetas.unshift(data)
    },
    removeEtiqueta(state, data){
        let index = state.etiquetas.map(x => x.id).indexOf(data.id);
        state.etiquetas.splice(index, 1)
    },
    setModalCadastrarEtiqueta(state, status) {
        state.modalCadastrarEtiqueta = status
    },
    setModalExcluirEtiqueta(state, status) {
        state.modalExcluirEtiqueta = status
    },
    setModalImprimirEtiqueta(state, status) {
        state.modalImprimirEtiqueta = status
    },
}

export default {}